var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52285 24.5004H0.40755V8.1434H5.52285V24.5004ZM2.96244 5.91215C1.32674 5.91215 0 4.56684 0 2.94262C1.17077e-08 2.16245 0.312114 1.41423 0.86768 0.862563C1.42325 0.310898 2.17676 0.000976562 2.96244 0.000976562C3.74813 0.000976562 4.50164 0.310898 5.05721 0.862563C5.61277 1.41423 5.92489 2.16245 5.92489 2.94262C5.92489 4.56684 4.5976 5.91215 2.96244 5.91215ZM24.6678 24.5004H19.5635V16.5379C19.5635 14.6403 19.5249 12.2067 16.9039 12.2067C14.2444 12.2067 13.8369 14.2684 13.8369 16.4012V24.5004H8.72707V8.1434H13.6331V10.3746H13.7047C14.3876 9.08949 16.0558 7.73324 18.5446 7.73324C23.7216 7.73324 24.6733 11.1184 24.6733 15.5153V24.5004H24.6678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6733,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a463803c21fa4168e29b5d18c0dcc756.svg";
export { ForwardRef as ReactComponent };